// Constants are renamed from PAGE_TOPPER prefix to CALLOUT_BANNER in anticipation of the extension rename to callout banner.
// Leaving the extension and type strings as page-topper, however, as the extension has already been added to a few instances
export var CALLOUT_BANNER_EXTENSION_KEY = 'page-topper';
export var CALLOUT_BANNER_EXTENSION_TYPE = 'com.atlassian.confluence.page-topper';
export var CALLOUT_BANNER_EXTENSION_ANALYTIC_SOURCE = 'calloutBannerExtension';